var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-note"},[_c('edit',{attrs:{"fs":_vm.orderNoteFields,"id":_vm.id,"title":_vm.title,"api":"orders"},on:{"changed":_vm.changed,"saved":_vm.saved}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }